import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import type { DeviceOption } from "app/pages/sales-intelligence/modules/find-apps-filters/types/commonEnums";
import type {
    AppsAndroidDownloadsAndEngagementDescriptionDto,
    AppsIosDownloadsAndEngagementDescriptionDto,
} from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsIosDownloadsAndEngagementFilter } from "app/pages/sales-intelligence/store/find-apps/types";
import type { ICountryObject } from "app/services/CountryService";

import { BaseDownloadsAndEngagementFilter } from "../DownloadEngagementFilter/BaseDownloadEngagementFilter";

interface IIosDownloadsAndEngagementOptions extends AppsAndroidDownloadsAndEngagementDescriptionDto {
    devices: readonly DeviceOption[];
}

export default class FindIosDownloadAndEngagementFilter extends BaseDownloadsAndEngagementFilter<
    IAppsIosDownloadsAndEngagementFilter,
    AppsIosDownloadsAndEngagementDescriptionDto
> {
    readonly devices: readonly DeviceOption[];

    constructor(
        deps: IFilterPanelBaseFilterDeps<
            IAppsIosDownloadsAndEngagementFilter,
            AppsIosDownloadsAndEngagementDescriptionDto
        > & {
            options: IIosDownloadsAndEngagementOptions;
            countries: readonly ICountryObject[];
        },
    ) {
        super(deps);
        this.devices = deps.options.devices;
    }
}
